import React from "react";
// css
import "./FellowSailor.css";
// assets
import sailorImg1 from "assets/Images/felloSlider/sailor-img-0.png";
import sailorImg2 from "assets/Images/felloSlider/sailor-img-1.png";
import sailorImg3 from "assets/Images/felloSlider/sailor-img-2.png";
import sailorImg5 from "assets/Images/felloSlider/sailor-img-4.png";

// component
import FellowSellerCard from "Utills/FellowSailorComponents/FellowSellerCard/FellowSailorCard";

// swiper config
import { Swiper, SwiperSlide } from "swiper/react";


// 
// FellowSailor {{Home  COMPONENT}}
const FellowSailor = () => {

  return (
    <>
      <section className="fellow_sailor">
        <div className="fellow_sailor_wraps">
          <h2 className="mb-4 text-white text-center">Fellow sailors share their amazing experiences</h2>
          <div className="fs_wrapper pt-5">
            <Swiper
              className="pt-5"
              initialSlide={0}
              slidesPerView={4}

              spaceBetween={15}
              breakpoints={{
                100: {
                  slidesPerView: 1
                },
                470: {
                  slidesPerView: 1
                },
                540: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 4
                },
                2500: {
                  slidesPerView: 4
                },
              }}
            >
              <SwiperSlide>
                <FellowSellerCard
                  topImg={sailorImg1}
                  name="Alexander Kriss"
                  date="July 10th 2021"
                  title="Zakynthos"
                  detail="The Experience is amazing! I could get to my booking on time without any mistakes. Gonna book again over and over. EXCELLENT JOB"
                />
              </SwiperSlide>
              <SwiperSlide>
                <FellowSellerCard
                  topImg={sailorImg2}
                  name="Jenifer Lorans"
                  date="July 10th 2021"
                  title="Zakynthos"
                  detail="The Experience is amazing! I could get to my booking on time without any mistakes. Gonna book again over and over. EXCELLENT JOB"
                />
              </SwiperSlide>
              <SwiperSlide>
                <FellowSellerCard
                  topImg={sailorImg3}
                  name="Julia Rodregez"
                  date="July 10th 2021"
                  title="Zakynthos"
                  detail="The Experience is amazing! I could get to my booking on time without any mistakes. Gonna book again over and over. EXCELLENT JOB"
                />
              </SwiperSlide>
              <SwiperSlide>
                <FellowSellerCard
                  topImg={sailorImg5}
                  name="Sara Conor"
                  date="July 10th 2021"
                  title="Zakynthos"
                  detail="The Experience is amazing! I could get to my booking on time without any mistakes. Gonna book again over and over. EXCELLENT JOB"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default FellowSailor;
